/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */

/**
 * author: tman
 */
import React from 'react';
import PropTypes from 'prop-types';
import QuestionMark from '../../../../shared/QuestionMark';

export default class ItemTitle extends React.Component {
  constructor(props) {
    super(props);

    this.state = props.params;
    this.questionContent = this.questionContent.bind(this);
  }
  //question content
  questionContent = ()=> {
    const {
      content,
      isNeedLabel,
    } = this.props;

    const _QM = content.questionMark;
    const Question = content.question;
    const QuestionTip = content.questionTip;
    const questionTitle = Question.title || Question.text || '';
    const dropDownBtnId = content.dropDownBtnId || '';
    const controlFor = content.controlFor || '';

    if (!!questionTitle) {
      return(
        <div id={`${dropDownBtnId || Question.dataKey}-label`}>
          { isNeedLabel ?
            <div className={_QM ? "item-sub-title question-mark-inline" : "item-sub-title"}>
            <label
              htmlFor={ controlFor }
              data-key={ Question.dataKey }
              id={`${dropDownBtnId}-title`}
            >
              { questionTitle && questionTitle }
              </label>
              {
                _QM &&
                <QuestionMark questionTitle={questionTitle}>
                  <hints dataKey={ _QM.dataKey }>{ _QM.hints }</hints>
                </QuestionMark>
              }
            </div>
            :
            <div
              data-key={ Question.dataKey }
              className="item-sub-title"
            >
              { questionTitle && questionTitle }
              {
                _QM &&
                <QuestionMark questionTitle={questionTitle}>
                  <hints dataKey={ _QM.dataKey }>{ _QM.hints }</hints>
                </QuestionMark>
              }
            </div>
          }

          { QuestionTip &&
          <p className="font-body3 item-question-tip"
             data-key={ QuestionTip.dataKey }
             id={`${ Question.dataKey }_tip`}
          >
            { QuestionTip.title }
          </p>
          }
        </div>
      )
    } else {
      return null;
    }
  };

  render() {
    const {
      content,
      className,
    } = this.props;

    const Question = content.question;
    const questionContent = this.questionContent(content);

    if (!!Question && !!questionContent) {
      return (
        <div className={`item-title clearfix ${className}`}>
          {questionContent}
        </div>
      )
    }

    return null;
  }
};

ItemTitle.propTypes = {
  content: PropTypes.object.isRequired,
  className: PropTypes.string,
  controlFor: PropTypes.string,
  isNeedLabel: PropTypes.bool
};

ItemTitle.defaultProps = {
  content: {},
  className: '',
  controlFor: '',
  isNeedLabel: true
};


// WEBPACK FOOTER //
// ./src/shared/AOForm/components/ItemTitle/index.js